import axios from '@/utils/request';

// 列表
export const getList = (params) => {
    return axios.get('/system/user/list', { params })
}

// 添加
export const add = (data) => {
    return axios.post('/system/user/add', { ...data })
}

// 编辑
export const edit = (data) => {
    return axios.put('/system/user/update', { ...data })
}

// 删除
export const delDept = (id) => {
    return axios.delete(`/system/user/${id}`)
}

// 角色
export const roleList = () => {
    return axios.get(`/system/role/listPage`, { pageCurr: 1, pageSize: 9999 })
}

// 禁用、启用
export const changeStatus = (data) => {
    return axios.post(`/system/user/shopUserStart`, { ...data })
}

// 重置密码
export const updatePwd = (data) => {
    return axios.put(`/system/user/resetPwd`, { ...data })
}